const MY_ACCOUNT_TAG_TYPES = {
  MY_ACCOUNT_PARENT: "MY_ACCOUNT_PARENT"
};

export const MY_ACCOUNT_TAGS = Object.values(MY_ACCOUNT_TAG_TYPES);
export default MY_ACCOUNT_TAG_TYPES;
